import { apiRequest } from "./client";
import type {
	ConfirmSubscriptionPayload,
	CreateSubscriptionResponse,
	SubscriptionPlanDto,
	SubscriptionStatusDto
} from "./types";

/**
 * List purchasable plans — currently the single monthly Pro plan (empty when payments are
 * unconfigured). Readable without a token so the public pricing page can show the real charged
 * amount before sign-in; passing a token adds the caller's CGST/SGST vs IGST split.
 */
export const getSubscriptionPlans = (token?: string | null): Promise<SubscriptionPlanDto[]> =>
	apiRequest<SubscriptionPlanDto[]>("/subscriptions/plans", { token });

/** Create (or reuse) a Razorpay subscription on the monthly Pro plan and get checkout parameters. */
export const createSubscription = (token: string): Promise<CreateSubscriptionResponse> =>
	apiRequest<CreateSubscriptionResponse>("/subscriptions/create", { method: "POST", token });

/** Confirm a completed Razorpay checkout; the server verifies the signature and activates Pro. */
export const confirmSubscription = (
	payload: ConfirmSubscriptionPayload,
	token: string
): Promise<SubscriptionStatusDto> =>
	apiRequest<SubscriptionStatusDto>("/subscriptions/confirm", { method: "POST", body: payload, token });

/** Cancel auto-renewal. Pro (and existing private trees) are kept until the paid period ends. */
export const cancelSubscription = (token: string): Promise<SubscriptionStatusDto> =>
	apiRequest<SubscriptionStatusDto>("/subscriptions/cancel", { method: "POST", token });

/** Current subscription status and Pro entitlement for the signed-in user. */
export const getSubscriptionStatus = (token: string): Promise<SubscriptionStatusDto> =>
	apiRequest<SubscriptionStatusDto>("/subscriptions/me", { token });
